<!-- Сводная карточка готового ФАКТа заказа и действие добавления расхода. -->
<template>
  <article class="fact-summary">
    <button
      class="fact-summary__toggle"
      type="button"
      :aria-expanded="expanded"
      :aria-label="expanded ? 'Свернуть детали плана и факта' : 'Показать детали плана и факта'"
      @click="$emit('toggle')"
    >
      <span class="fact-summary__badge">ФАКТ</span>
      <span class="fact-summary__main">
        <span class="fact-summary__status">
          <span class="fact-summary__status-dot" :class="`fact-summary__status-dot--${statusTone}`"></span>
          {{ statusLabel }}
        </span>
        <strong v-if="canViewExpenses && profit !== null">
          Фактическая прибыль {{ formatRub(profit) }}
        </strong>
        <strong v-else-if="canViewExpenses" class="fact-summary__empty-value">
          Прибыль не рассчитана
        </strong>
        <strong v-else class="fact-summary__empty-value">—</strong>
      </span>
      <PlanCalculationSummaryMetric
        v-if="canViewExpenses"
        label="Расстояние"
        :value="formatMileage(mileage)"
      />
      <PlanCalculationSummaryMetric
        v-if="canViewExpenses"
        label="р/км"
        :value="formatProfitPerKm(profitPerKm)"
      />
      <PlanCalculationDisclosureIcon
        class="fact-summary__chevron"
        :expanded="expanded"
      />
    </button>
    <span v-if="canCreateExpense" class="fact-summary__divider"></span>
    <span v-if="canCreateExpense" class="fact-summary__action">
      <PlanCalculationActionButton
        class="fact-summary__expense-button"
        tone="fact"
        appearance="soft"
        @click="$emit('add-expense')"
      >
        + Записать расход
      </PlanCalculationActionButton>
    </span>
  </article>
</template>

<script>
import PlanCalculationActionButton from "@/components/Order/PlanCalculation/Buttons/Action.vue";
import PlanCalculationDisclosureIcon from "@/components/Order/PlanCalculation/Buttons/DisclosureIcon.vue";
import PlanCalculationSummaryMetric from "@/components/Order/PlanCalculation/SummaryMetric.vue";
import { formatBigNumber } from "@/utils/numberUtils";

export default {
  name: "OrderPlanCalculationFactSummary",

  components: {
    PlanCalculationActionButton,
    PlanCalculationDisclosureIcon,
    PlanCalculationSummaryMetric,
  },

  props: {
    expanded: { type: Boolean, default: false },
    canViewExpenses: { type: Boolean, default: false },
    canCreateExpense: { type: Boolean, default: false },
    statusLabel: { type: String, default: "" },
    statusTone: { type: String, default: "muted" },
    profit: { type: [String, Number], default: null },
    mileage: { type: [String, Number], default: null },
    profitPerKm: { type: [String, Number], default: null },
  },

  emits: ["toggle", "add-expense"],

  methods: {
    formatRub(value) {
      return `${formatBigNumber(value)} ₽`;
    },
    formatMileage(value) {
      return value === null ? "—" : `${formatBigNumber(value)} км`;
    },
    formatProfitPerKm(value) {
      return value === null ? "—" : formatBigNumber(value);
    },
  },
};
</script>

<style scoped>
.fact-summary {
  width: 100%;
  display: flex;
  align-items: stretch;
  min-height: 64px;
  box-sizing: border-box;
  border: 1px solid #fed7aa;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  color: inherit;
}

.fact-summary:hover,
.fact-summary:focus-within {
  border-color: #c2410c;
}

.fact-summary__toggle {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 10px 12px 10px 14px;
  border: 0;
  background: transparent;
  color: inherit;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
}

.fact-summary__toggle:hover:not(:disabled),
.fact-summary__toggle:focus-visible:not(:disabled) {
  background: #fffaf7;
  outline: none;
}

.fact-summary__toggle:disabled {
  cursor: default;
}

.fact-summary__badge {
  flex: none;
  padding: 5px 10px;
  border-radius: 6px;
  background: #c2410c;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.8px;
}

.fact-summary__main {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.fact-summary__main > strong {
  font-size: 14px;
  font-weight: 600;
}

.fact-summary__status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #9a3412;
  font-size: 11px;
}

.fact-summary__status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #6b7280;
}

.fact-summary__status-dot--planned {
  background: #ca8a04;
}

.fact-summary__status-dot--progress {
  background: #ea580c;
}

.fact-summary__status-dot--completed {
  background: #047a69;
}

.fact-summary__empty-value {
  color: #5b6070;
}

.fact-summary__chevron {
  flex: none;
  margin-left: auto;
  color: #c2410c;
}

.fact-summary__divider {
  width: 1px;
  margin: 12px 0;
  background: #ffedd5;
}

.fact-summary__action {
  flex: none;
  display: flex;
  align-items: center;
  padding: 0 12px;
}

@container (max-width: 620px) {
  .fact-summary {
    flex-wrap: wrap;
  }

  .fact-summary__toggle {
    flex-basis: 100%;
    flex-wrap: wrap;
    gap: 10px 18px;
  }

  .fact-summary__divider {
    width: 100%;
    height: 1px;
    margin: 0;
  }

  .fact-summary__action {
    width: 100%;
    justify-content: flex-end;
    padding: 10px 12px;
  }
}
</style>
